import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { useTranslation } from 'react-i18next';
import Spacer from 'components/spacer/Spacer';
import { useLivenStatementQuestionLogic } from 'onboarding/question/livenstatement/LivenStatementQuestion.hook';
import { LivenStatementQuestion } from 'onboarding/question/livenstatement/LivenStatementQuestion';
import { Option } from './LivenStatementQuestion.constants';
import styles from './styles.module.scss';

type Props = QuestionComponentProps<LivenStatementQuestion>;

export const LivenStatementQuestionComponent: React.FC<Props> = ({
  question,
}: Props) => {
  const { t } = useTranslation();

  const { activeOption, options, containerStyle, optionHandler } =
    useLivenStatementQuestionLogic(question);

  return (
    <div
      className={`
        ${styles.container}
        ${styles[containerStyle]}   
        ${styles.speed}  
        maxWidth
      `}
    >
      <h3 className={styles.title}>{t(question.title)}</h3>
      <h2 className={styles.statement}>{t(question.statement)}</h2>
      <Spacer />
      <div className={styles.options}>
        {options.map((option: Option, index) => (
          <div
            key={option.id}
            className={styles.buttonWrapper}
            onClick={(e) => optionHandler(option)(e)}
          >
            <button
              className={`
                ${styles[index === 0 ? 'first' : '']}
                ${styles[options.length - 1 === index ? 'last' : '']}
                ${styles.option} 
                ${activeOption === option.id ? styles.active : ''}
              `}
            />
            <img src={option.icon} alt="" />
          </div>
        ))}
      </div>
      <div className={styles.note}>
        <p>Strongly disagree</p>
        <p>Strongly agree</p>
      </div>
      <Spacer />
    </div>
  );
};
